import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  Stack,
  IconButton,
  Divider,
  alpha,
  useTheme,
  Chip,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  Inventory as InventoryIcon,
  Add as AddIcon,
  Print as PrintIcon,
  ArrowForwardIos as ArrowIcon,
} from "@mui/icons-material";
import PersonalInventoryModal from "./PersonalInventoryModal";

const PersonalInventory = () => {
  const theme = useTheme();
  const [showInventoryModal, setShowInventoryModal] = useState(false);

  const handleInventoryShow = () => setShowInventoryModal(true);
  const handleInventoryClose = () => setShowInventoryModal(false);

  const inventoryData = [];

  return (
    <>
      <Card
        sx={{
          borderRadius: "12px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: "#FAFBFC",
            borderBottom: "1px solid #F2F4F7",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: "6px",
                bgcolor: alpha(theme.palette.info.main, 0.08),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <InventoryIcon sx={{ color: theme.palette.info.main, fontSize: 16 }} />
            </Box>
            <Typography variant="subtitle2" fontWeight={600} sx={{ color: "#1A1A2E", fontSize: "0.85rem" }}>
              Personal Inventory
            </Typography>
            <Chip
              label={inventoryData.length}
              size="small"
              sx={{
                height: 18,
                fontSize: "0.55rem",
                fontWeight: 500,
                bgcolor: "#F2F4F7",
                color: "#667085",
              }}
            />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <IconButton
              size="small"
              sx={{
                width: 28,
                height: 28,
                color: "#667085",
                "&:hover": {
                  bgcolor: "#F2F4F7",
                  color: "#1A1A2E",
                },
              }}
            >
              <PrintIcon sx={{ fontSize: 16 }} />
            </IconButton>
            <IconButton
              onClick={handleInventoryShow}
              size="small"
              sx={{
                width: 28,
                height: 28,
                bgcolor: "#2469F0",
                color: "#fff",
                "&:hover": {
                  bgcolor: "#1A5BD4",
                },
              }}
            >
              <AddIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>
        </Box>

        <Divider sx={{ opacity: 0.4 }} />

        <CardContent sx={{ p: 0 }}>
          {inventoryData.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <Typography variant="body2" sx={{ color: "#667085", fontSize: "0.85rem" }}>
                No inventory records found
              </Typography>
              <Button
                variant="text"
                size="small"
                onClick={handleInventoryShow}
                sx={{
                  mt: 1,
                  textTransform: "none",
                  color: "#2469F0",
                  fontWeight: 500,
                  "&:hover": {
                    bgcolor: alpha("#2469F0", 0.04),
                  },
                }}
              >
                Add your first inventory item
              </Button>
            </Box>
          ) : (
            <TableContainer>
              <Table size="small">
                <TableHead sx={{ bgcolor: "#F8FAFC" }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "#475467", fontSize: "0.75rem" }}>
                      Item
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, color: "#475467", fontSize: "0.75rem" }}>
                      Quantity
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, color: "#475467", fontSize: "0.75rem" }}>
                      Location
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, color: "#475467", fontSize: "0.75rem" }}>
                      Deposited
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, color: "#475467", fontSize: "0.75rem" }}>
                      Released
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {inventoryData.map((item, index) => (
                    <TableRow key={index} hover>
                      <TableCell sx={{ fontSize: "0.8rem", color: "#1A1A2E" }}>
                        {item.name}
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.8rem", color: "#1A1A2E" }}>
                        {item.quantity}
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.8rem", color: "#1A1A2E" }}>
                        {item.location}
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.8rem", color: "#1A1A2E" }}>
                        {item.deposited}
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.8rem", color: "#1A1A2E" }}>
                        {item.released || "-"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>

      <PersonalInventoryModal
        show={showInventoryModal}
        onHide={handleInventoryClose}
      />
    </>
  );
};

export default PersonalInventory;